import { render } from "./UserEdit.vue?vue&type=template&id=cf67fcd4&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=cf67fcd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf67fcd4"]])

export default __exports__